import {
    AREA_CODES,
    ECountryCode,
} from 'src/modules/forms/fields/AreaCodeTextField/components/AreaCodeSelect';

const DIAL_CODE_PREFIX = '+';

const getDialCode = (countryCode: ECountryCode): string =>
    AREA_CODES[countryCode]?.code.replace(DIAL_CODE_PREFIX, '') ?? '';

export const getContactWhatsAppPhone = (
    phone?: string,
    countryCode: ECountryCode = ECountryCode.Mexico
): string | null => {
    const digits = phone?.replace(/\D/g, '') ?? '';

    if (!digits) return null;

    const dialCode = getDialCode(countryCode);
    const internationalPhone =
        digits.startsWith(dialCode) && digits.length > 10
            ? digits
            : `${dialCode}${digits}`;

    return internationalPhone;
};
